module.exports = __webpack_public_path__ + "static/propertyrentals-262f401c64e19d0c8410c6cffffc7c02.png";